import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
	selector: 'app-dynamic-text-area',
	templateUrl: './dynamic-text-area.component.html',
	styleUrls: [],
	encapsulation: ViewEncapsulation.None,
	viewProviders: [
		{ provide: ControlContainer, useExisting: FormGroupDirective }
	]
})
export class DynamicTextAreaComponent {
	@Input() field: any;

	constructor(public controlContainer: ControlContainer) {}
}
